import React, {
  Dispatch,
  SetStateAction,
  createContext,
  useContext,
  useState,
} from "react";

type AddressData = {
  address: string;
  city: string;
  complement: string;
  fullAddress: string;
  neighborhood: string;
  number: string;
  stateCode: string;
  zipCode: string;
};

type AddressShipLetterToData = {
  address: string;
  city: string;
  complement: string;
  fullAddress: string;
  neighborhood: string;
  number: string;
  stateCode: string;
  zipCode: string;
};

type AddNewUnitTDO = {
  externalCondominiumId: string;
  externalBlockId: string;
  condominiumName: string;
  externalUnitId: string;
  unitInstanceId: string;
  name: string;
  address: AddressData;
  typeSelector?: "cep" | "code";
  hasGasMeter?: boolean;
  hasGasReleased?: boolean;
  dueDay?: string | Date;
  deliveryType?: string;
  addressShipLetterTo?: AddressShipLetterToData;
};

type AddNewUnitContextData = {
  newUnitData: AddNewUnitTDO;
  setNewUnitData: Dispatch<SetStateAction<AddNewUnitTDO>>;
  step: number;
  setStep: Dispatch<SetStateAction<number>>;
  typeSelector: string;
  setTypeSelector: Dispatch<SetStateAction<string>>;
  condoZipCode: string;
  setCondoZipCode: Dispatch<SetStateAction<string>>;
  condoCode: string;
  setCondoCode: Dispatch<SetStateAction<string>>;
  externalUnitId: string;
  setExternalUnitId: Dispatch<SetStateAction<string>>;
};

const AddNewUnitContext = createContext({} as AddNewUnitContextData);

type AddNewUnitProviderProps = {
  children: React.ReactNode;
};

export const AddNewUnitProvider = ({
  children,
}: AddNewUnitProviderProps): JSX.Element => {
  const [step, setStep] = useState(1);
  const [typeSelector, setTypeSelector] = useState("cep");
  const [condoZipCode, setCondoZipCode] = useState("");
  const [condoCode, setCondoCode] = useState("");
  const [externalUnitId, setExternalUnitId] = useState("");
  const [newUnitData, setNewUnitData] = useState<AddNewUnitTDO>(
    {} as AddNewUnitTDO
  );

  return (
    <AddNewUnitContext.Provider
      // eslint-disable-next-line react/jsx-no-constructed-context-values
      value={{
        step,
        setStep,
        typeSelector,
        setTypeSelector,
        condoZipCode,
        setCondoZipCode,
        condoCode,
        setCondoCode,
        externalUnitId,
        setExternalUnitId,
        newUnitData,
        setNewUnitData,
      }}
    >
      {children}
    </AddNewUnitContext.Provider>
  );
};

export function useAddNewunit(): AddNewUnitContextData {
  return useContext(AddNewUnitContext);
}
